import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { collection, query, where, getDocs } from "firebase/firestore";
import { analytics, db, logEvent } from "../firebase/firebase";
import ReadOnlySlatePage from "./SlateEditor/ReadOnlySlate";
import PageNotAssigned from './PageNotAssigned'; // Importiere den Modal-Component
import { Modal, Button } from "react-bootstrap";

function DynamicPage() {
  const { link } = useParams(); // Hole die Seiten-Link aus der URL
  const [loading, setLoading] = useState(true);
  const [contentType, setContentType] = useState(null);
  const [content, setContent] = useState(null);
  const [showModal, setShowModal] = useState(false); // Zeigt das Modal an
  const [redirecting, setRedirecting] = useState(false); // Status für die Weiterleitung

  useEffect(() => {
    const fetchPageData = async () => {
      try {
        const pagesCollection = collection(db, "pages");
        const pageQuery = query(pagesCollection, where("link", "==", link));
        const querySnapshot = await getDocs(pageQuery);

        if (!querySnapshot.empty) {
          const pageData = querySnapshot.docs[0].data();
          setContentType(pageData.contentType);
          setContent(pageData.content[pageData.contentType]);
        } else {
          setContent(null); // Keine Seite gefunden
        }
      } catch (err) {
        console.error("Fehler beim Laden der Seite:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchPageData();
  }, [link]);

  useEffect(() => {
    if (contentType && content) {
      logEvent(analytics, "page_view", {
        page_link: link, // Speichert den spezifischen Seitenlink
      });
    }
  }, [contentType, content, link]);

  useEffect(() => {
    if (contentType === "url" && content) {
      setShowModal(true); // Zeigt das Modal an
      const timer = setTimeout(() => {
        setRedirecting(true); // Setze Weiterleitungsstatus
        window.location.href = content; // Leite den Benutzer weiter
      }, 3000); // Verzögerung von 3 Sekunden

      return () => clearTimeout(timer); // Timer bereinigen
    }
  }, [contentType, content]);

  if (loading) {
    return <p>Lädt...</p>;
  }

  if (!content) {
    return <PageNotAssigned />;
  }

  if (redirecting) {
    return null; // Kein weiteres Rendering nach Weiterleitung
  }

  return (
    <div>
      <Modal show={showModal} centered>
        <Modal.Header>
          <Modal.Title>Weiterleitung</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Powered by</p>
          <div className="d-flex justify-content-center mt-3">
            <a
              href="https://www.qr-shirt.de"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://www.qr-shirt.de/wp-content/uploads/2025/02/logo_ohne_Hintergrund.png"
                alt="QR-Shirt Logo"
                style={{ maxWidth: "200px", height: "auto" }}
              />
            </a>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Abbrechen
          </Button>
        </Modal.Footer>
      </Modal>

      {contentType === "text" && <ReadOnlySlatePage content={content} />}
      {contentType === "image" && (
        <img src={content} alt="Benutzerbild" style={{ maxWidth: "100%" }} />
      )}

      {/* 🔹 Fixiertes Banner unten rechts */}
      <div className="position-fixed bottom-0 end-0">
        <a 
          href="https://www.qr-shirt.de" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="d-inline-block text-decoration-none text-black px-3 py-2"
          style={{
            backgroundColor: "#1b578b",
            borderRadius: "10px 0 0 0",
            fontSize: "14px",
            fontWeight: "bold",
            boxShadow: "0px 0px 10px rgba(0,0,0,0.3)"
          }}
        >
          by qr-shirt.de  &nbsp;
          <img 
            src="/logo32.png" 
            alt="QR-Shirt Logo"
            style={{
              height: "20px",
            }}
          />
        </a>
      </div>
    </div>
  );
}

export default DynamicPage;
